export default {
  paywall: {
    actions: {
      notNow: "Pas maintenant",
      noThanks: "Non merci",
      skip: "Passer",
    },
    generic: {
      title: "Débloquez l'expérience complète",
      subtitle: "Accédez à tout ce qu'il vous faut pour analyser, construire et placer de meilleurs paris",
      whyJoin: "Pourquoi rejoindre Linemate+?",
      comparePlans: "Comparer les forfaits",
      renewalDisclaimer: "Le forfait se renouvelle automatiquement. Annulez en tout temps.",
    },
    sources: {
      injuryImpact: {
        title: "Débloquer l'impact des blessures",
        subtitle: "Voyez comment les blessures influencent les coéquipiers. Analysez chaque tendance plus en profondeur",
      },
      startingLineups: {
        title: "Débloquer les formations partantes",
        subtitle: "Trouvez de la valeur lorsque les formations changent. Analysez chaque tendance plus en profondeur",
      },
      opponentRank: {
        title: "Débloquer le classement défensif adverse",
        subtitle: "Exploitez les affrontements défensifs favorables.\nAnalysez chaque tendance plus en profondeur",
      },
      weatherReport: {
        title: "Débloquer la météo",
        subtitle: "Utilisez le vent et la météo à votre avantage.\nAnalysez chaque tendance plus en profondeur",
      },
      startingPitchers: {
        title: "Débloquer les lanceurs partants adverses",
        subtitle: "Ciblez les situations contre les lanceurs vulnérables.\nAnalysez chaque tendance plus en profondeur",
      },
    },
    features: {
      injuryImpact: {
        title: "Impact des blessures",
        description: "Voyez comment les blessures influencent les coéquipiers.",
      },
      startingLineups: {
        title: "Formations partantes",
        description: "Trouvez de la valeur lorsque les formations changent.",
      },
      opponentRank: {
        title: "Classement défensif adverse",
        description: "Exploitez les affrontements défensifs favorables.",
      },
      weatherReport: {
        title: "Météo",
        description: "Utilisez le vent et la météo à votre avantage.",
      },
      startingPitchers: {
        title: "Lanceurs partants adverses",
        description: "Ciblez les situations contre les lanceurs vulnérables.",
      },
    },
    comparison: {
      title: "Fonctionnalités",
      free: "Gratuit",
      rows: {
        dailyTeamAndPlayerTrends: "Tendances quotidiennes équipes et joueurs",
        dailyParlayTrends: "Tendances quotidiennes de combinés",
        teamAndPlayerPropsTool: "Outil de props équipes et joueurs",
        statsAndStandings: "Stats et classements",
        dailyCheatsheets: "Aide-mémoire quotidiens",
        advancedSignalsAndTools: "Signaux et outils avancés",
        startingLineups: "Formations partantes",
        injuryImpact: "Impact des blessures",
        opponentDefensiveRank: "Classement défensif adverse",
        weatherReports: "Météo",
        startingOpponentPitchers: "Lanceurs partants adverses",
      },
    },
    plans: {
      bestValue: "Meilleure valeur",
      annual: "Annuel",
      monthly: "Mensuel",
      yearlyPlan: "Forfait annuel",
      monthlyPlan: "Forfait mensuel",
      perYearShort: "an",
      perMonthShort: "mois",
    },
    onboarding: {
      trialTitle: "Commencez votre essai gratuit de 7 jours",
      trialSubtitle: "Choisissez un forfait pour continuer après la fin de votre essai",
    },
    cta: {
      claimYourCode: "Utilisez votre code",
      startYourFreeTrial: "Commencer votre essai gratuit",
      startMy7DayFreeTrial: "Commencer mon essai gratuit de 7 jours",
      tryFreeAndSubscribe: "Essayer gratuitement et s'abonner",
      upgradeToLinematePlus: "Passer à Linemate+",
    },
    trial: {
      sevenDaysFree: "7 jours gratuits",
      thenPerMonth: "{{trial}}, puis {{price}} par mois",
      thenPerYear: "{{trial}}, puis {{price}} par an ({{monthlyPrice}}/{{perMonthShort}})",
      startingOn: " à partir du {{date}}",
      standardPerMonth: "{{price}} par mois",
      standardPerYear: "{{price}} par an ({{monthlyPrice}}/{{perMonthShort}})",
      subtitleSuffix: " avec un essai gratuit de 7 jours.",
    },
  },
};
